/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptConsentRequest,
  ConsentVersionDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * @summary Fetch the current POPIA consent text. Public — the mobile signup screen calls this before the user has any credentials.
 */
export const consentControllerGetCurrent = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<ConsentVersionDto>(
      {url: `/consent/current`, method: 'GET', signal
    },
      );
    }
  



export const getConsentControllerGetCurrentQueryKey = () => {
    return [
    `/consent/current`
    ] as const;
    }

    
export const getConsentControllerGetCurrentQueryOptions = <TData = Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsentControllerGetCurrentQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consentControllerGetCurrent>>> = ({ signal }) => consentControllerGetCurrent(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ConsentControllerGetCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof consentControllerGetCurrent>>>
export type ConsentControllerGetCurrentQueryError = unknown


export function useConsentControllerGetCurrent<TData = Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentControllerGetCurrent>>,
          TError,
          Awaited<ReturnType<typeof consentControllerGetCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useConsentControllerGetCurrent<TData = Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof consentControllerGetCurrent>>,
          TError,
          Awaited<ReturnType<typeof consentControllerGetCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useConsentControllerGetCurrent<TData = Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Fetch the current POPIA consent text. Public — the mobile signup screen calls this before the user has any credentials.
 */

export function useConsentControllerGetCurrent<TData = Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consentControllerGetCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getConsentControllerGetCurrentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Record acceptance of a specific consent version. Idempotent. Signup already records this implicitly via /auth/signup — this endpoint is for re-consent on version bumps.
 */
export const consentControllerAccept = (
    acceptConsentRequest: AcceptConsentRequest,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<void>(
      {url: `/consent/accept`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptConsentRequest, signal
    },
      );
    }
  


export const getConsentControllerAcceptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentControllerAccept>>, TError,{data: AcceptConsentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consentControllerAccept>>, TError,{data: AcceptConsentRequest}, TContext> => {

const mutationKey = ['consentControllerAccept'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consentControllerAccept>>, {data: AcceptConsentRequest}> = (props) => {
          const {data} = props ?? {};

          return  consentControllerAccept(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConsentControllerAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof consentControllerAccept>>>
    export type ConsentControllerAcceptMutationBody = AcceptConsentRequest
    export type ConsentControllerAcceptMutationError = unknown

    /**
 * @summary Record acceptance of a specific consent version. Idempotent. Signup already records this implicitly via /auth/signup — this endpoint is for re-consent on version bumps.
 */
export const useConsentControllerAccept = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consentControllerAccept>>, TError,{data: AcceptConsentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof consentControllerAccept>>,
        TError,
        {data: AcceptConsentRequest},
        TContext
      > => {

      const mutationOptions = getConsentControllerAcceptMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    